import React from 'react';
export function UniqueMechanism() {
  return <section className="w-full bg-beige py-12 md:py-20 px-4" data-id="element-240">
      <div className="max-w-[680px] mx-auto" data-id="element-241">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray text-center mb-6" data-id="element-242">
          🔑 Por Qué Esto Funciona Cuando Todo lo Demás No Funcionó
        </h2>

        <p className="font-body text-dark-gray text-base md:text-lg leading-relaxed text-center mb-8" data-id="element-243">
          La mayoría de las guías de crochet te enseñan qué hacer. Este ebook te
          enseña por qué funciona — en el orden exacto en que tus manos y tus
          ojos necesitan aprenderlo.
        </p>

        <h3 className="font-heading font-bold text-xl md:text-2xl text-pink-dark text-center mb-8" data-id="element-244">
          Presentamos el Método de Patrón Visual Progresivo™
        </h3>

        {/* Comparison Table */}
        <div className="rounded-2xl overflow-hidden shadow-md mb-8" data-id="element-245">
          {/* Headers */}
          <div className="grid grid-cols-2" data-id="element-246">
            <div className="bg-red-50 p-4 text-center font-body font-bold text-dark-gray text-sm md:text-base" data-id="element-247">
              ❌ La forma tradicional
            </div>
            <div className="bg-green-50 p-4 text-center font-body font-bold text-dark-gray text-sm md:text-base" data-id="element-248">
              ✅ Este ebook
            </div>
          </div>

          {/* Row 1 */}
          <div className="grid grid-cols-2 border-t border-gray-100" data-id="element-249">
            <div className="bg-red-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-250">
              Códigos escritos como "sc, dc, ch3" sin contexto
            </div>
            <div className="bg-green-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-251">
              Diagramas visuales primero, luego pasos escritos simples
            </div>
          </div>

          {/* Row 2 */}
          <div className="grid grid-cols-2 border-t border-gray-100" data-id="element-252">
            <div className="bg-red-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-253">
              Asume conocimiento previo
            </div>
            <div className="bg-green-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-254">
              Empieza desde cero absoluto
            </div>
          </div>

          {/* Row 3 */}
          <div className="grid grid-cols-2 border-t border-gray-100" data-id="element-255">
            <div className="bg-red-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-256">
              Un tutorial largo que nunca terminás
            </div>
            <div className="bg-green-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-257">
              Secciones cortas que completás en una sentada
            </div>
          </div>

          {/* Row 4 */}
          <div className="grid grid-cols-2 border-t border-gray-100" data-id="element-258">
            <div className="bg-red-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-259">
              Tallas genéricas que no te quedan
            </div>
            <div className="bg-green-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-260">
              Patrones ajustables para cada tipo de cuerpo
            </div>
          </div>

          {/* Row 5 */}
          <div className="grid grid-cols-2 border-t border-gray-100" data-id="element-261">
            <div className="bg-red-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-262">
              Sin ayuda cuando te trabás
            </div>
            <div className="bg-green-50/50 p-4 font-body text-sm md:text-base text-dark-gray" data-id="element-263">
              Resolución de problemas integrada en cada patrón
            </div>
          </div>
        </div>

        <p className="italic text-center text-medium-gray font-body text-base" data-id="element-264">
          Por eso las principiantes terminan su primera pieza en 24–48 horas en
          lugar de abandonar en la primera hora.
        </p>
      </div>
    </section>;
}